import { ReactNode } from "react";
import { Link } from "react-router-dom";

interface BannerDirect {
    type?: string;
    title: string;
    content: string;
    color: string;
    image: ReactNode;
    linkTo: string;
}

const BannerDirect = ({ type, title, content, color, image, linkTo }: BannerDirect) => {
    return (
        <Link
            to={linkTo}
            className={`relative cursor-pointer ${type === "express" ? "w-[588px]" : "w-[436px]"} h-[262px] flex flex-col bg-white border rounded-[20px] pt-[30px] px-[38px]`}
        >
            <p className="pb-[15px] text-[22px] font-bold">{title}</p>
            <p className="text-sm pb-[32px] text-[#666]" dangerouslySetInnerHTML={{ __html: content }}></p>

            <div
                className={`w-[100px] rounded-full text-sm font-[500] p-[5px] ${color === "air" ? "bg-air" : color === "morning" ? "bg-morning" : color === "quick" ? "bg-quick" : "bg-express"} text-white text-center`}
            >
                바로가기
            </div>
            <div>{image}</div>
        </Link>
    );
};

export default BannerDirect;
